import { SeverityDropdown } from '../../severity-dropdown/SeverityDropdown';
import React from 'react';

export const SeverityFilter = ({ updateFilter, value, label }) => (
    <SeverityDropdown
        label={label}
        selectSeverityLevel={change => updateFilter(change.value)}
        selectedSeverityLevel={value}
    />
);
